
import { Component, Vue } from 'vue-property-decorator'
import VersionService from '@/biz/service/System/VersionService'

@Component
export default class ViewSystemVersionIndex extends Vue {
  private Service = VersionService
}
